/*
 * Presentación de importes y etiquetas del incremento 2/6.
 *
 * Los importes viajan como CADENA DECIMAL, nunca como number (RNF-001): aquí solo
 * se les da formato para mostrarlos y jamás se opera con ellos. Todo cálculo —el
 * saldo, la deuda, el disponible y el total por moneda— lo hace el servidor
 * (D-24); si esta pantalla sumara, habría dos verdades.
 */

/*
 * BARRIDO D-88 / RN-147: esta pantalla DEJÓ DE FORMATEAR POR SU CUENTA. El formato
 * de importe es uno solo para todo el sistema y vive en
 * `nucleo/importes/formatoDeImporte.js`; aquí sólo se reexporta con el nombre que
 * ya usaban las pantallas del 2/6, para no tocar sus importaciones.
 *
 * El segundo argumento ya NO es el símbolo de la moneda, es su CÓDIGO (`MXN` /
 * `USD`): el símbolo es `$` para las dos divisas y el código va al final
 * (RN-146a, RN-146d). El prefijo propio del dólar quedó derogado (RN-147b).
 */
export { formatearImporte as importe } from '../../nucleo/importes/formatoDeImporte.js';

export function esCero(cadena) {
  return Number(cadena ?? NaN) === 0;
}

/** Iniciales para el cuadro de color de la fila, como en el prototipo. */
export function iniciales(nombre) {
  return (nombre ?? '')
    .split(' ')
    .filter(Boolean)
    .slice(0, 2)
    .map((parte) => parte[0])
    .join('')
    .toUpperCase() || '··';
}

export function vigencia(mes, anio) {
  if (!mes || !anio) return null;
  return `${String(mes).padStart(2, '0')}/${anio}`;
}

/**
 * Una vigencia pasada NO caduca la cuenta, no la desactiva y no genera aviso: solo
 * dice que ya tocó renovar el plástico (S-24, RN-070f). Se muestra como etiqueta
 * informativa y nada más.
 */
export function vigenciaVencida(mes, anio, hoy) {
  if (!mes || !anio || !hoy) return false;
  const [anioHoy, mesHoy] = hoy.split('-').map(Number);
  return anio < anioHoy || (anio === anioHoy && mes < mesHoy);
}

/** Agrupa por moneda respetando el orden que ya trae el servidor (RN-071f). */
export function agruparPorMoneda(cuentas) {
  const bloques = [];
  cuentas.forEach((cuenta) => {
    let bloque = bloques.find((b) => b.idMoneda === cuenta.idMoneda);
    if (!bloque) {
      bloque = { idMoneda: cuenta.idMoneda, codigoISO: cuenta.codigoISO, simbolo: cuenta.simbolo, cuentas: [] };
      bloques.push(bloque);
    }
    bloque.cuentas.push(cuenta);
  });
  return bloques;
}

export const NOMBRE_DE_MONEDA = { MXN: 'Pesos mexicanos', USD: 'Dólares' };
